import {Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {ConfigStateService} from "../../../../../app/config/config-state.service";
import { ClientService, TaxReturnService } from "../../../../../../swaggerServices";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "create-batch",
    templateUrl: "./create-batch.component.html",
    styleUrls: ["./create-batch.component.scss"],
    standalone: false
})
export class CreateBatch implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() currentClientId;
  @Input() year;
  @Input() customFilters;
  @Input() taxReturnTypeById
  @Input() taxReturnSubTypeById
  @Input() client
  @Input() taxReturnAlias: string;
  @Output() completed = new EventEmitter();
  newBatchForm: UntypedFormGroup = new UntypedFormGroup({}); // form for new client creation
  batchName: string; // new batch input
  showModal = true;
  responseData = [];
  bulkActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  errorMessage = "";
  batchNameInput;

  private unsubscribe: Subject<void> = new Subject();
  constructor(
              private taxReturnService: TaxReturnService,
              private clientService: ClientService,
              private config: ConfigStateService,
              @Optional() private dialogRef?: MatDialogRef<CreateBatch>,
              @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<CreateBatch>) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns ?  Object.keys(this.selectedTaxReturns).map(n=>Number(n)) : [];
  }

  get submitButtonDisabled() {
    return !this.currentClientId || this.bulkActionState==='LOADING' || !this.batchName;
  }

  ngOnInit() {
      this.bulkActionState = 'OPENED';
      this.errorMessage = '';
      if (!this.currentClientId) {
        this.errorMessage = 'Client id is not provided';
        return;
      }
      this.batchNameInput = new UntypedFormControl("");
      this.initBatchName();
      this.newBatchForm.addControl("batchName", this.batchNameInput);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  initBatchName(){
    // subtype and type check
    let firstSubTypeName = '';
    let allSameSubtype = true;
    let firstTypeName = '';
    let allSameType = true;

    Object.entries(this.selectedTaxReturns).forEach((k, v) => {
      const currentTr:any = k[1];
      if(v === 0){
        firstSubTypeName = currentTr.taxReturnSubTypeName;
        firstTypeName = currentTr.taxReturnTypeName;
      } else {
        // only save unique names
        if(allSameSubtype && currentTr.taxReturnSubTypeName !== firstSubTypeName){
          allSameSubtype = false;
          firstSubTypeName = '';
        }
        if(allSameType && currentTr.taxReturnTypeName !== firstTypeName){
          allSameType = false;
          firstTypeName = '';
        }
      }
    })

    // client name
    const clientName = this.client.name;
    // custom filters selected
    // remove [BLANK] and ALL entries
    const activeFilters = this.customFilters.filter(f => f !== "All" && f !== "[BLANK]")
    const customFilters = activeFilters.length ?  activeFilters.join("-") : '';
    this.batchName =  `${firstSubTypeName}${firstSubTypeName? '-':''}${clientName}${customFilters? '-':''}${customFilters}${firstTypeName?'-':''}${firstTypeName}`
  }

  createBatch() {
    
    this.errorMessage = '';
    this.bulkActionState = 'LOADING';
      this.clientService.createNewBatch({ name: this.batchName, clientId: parseInt(this.currentClientId), year: parseInt(this.year), taxReturnIds: this.selectedTaxReturnIds})
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(resp => {
        this.bulkActionState = 'COMPLETED';
      }, error => {
        this.errorMessage = "Something went wrong, please check error message and try again.";
        this.bulkActionState = 'OPENED';
        return;
      });
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showModal = false;
    this.completed.emit();
  }

}
